import { IBaseVraagboomResultaat } from './base.vraagboom.resultaat';

export class VraagboomNumberResultaat implements IBaseVraagboomResultaat {
  value: string;

  constructor() {
    this.value = '';
  }
}
